import { useEffect, useState } from "react";
import { isNativeApp } from "@/lib/nativeApp";

export default function NativeUpdateNotice() {
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    if (!isNativeApp()) return undefined;
    let active = true;
    const current = document.querySelector('meta[name="salesmachine-build"]')?.content;
    const check = async () => {
      if (!current || document.visibilityState === "hidden") return;
      try {
        const response = await fetch(`/app-version.json?t=${Date.now()}`, { cache: "no-store" });
        if (!response.ok) return;
        const latest = await response.json();
        if (active) setAvailable(typeof latest.version === "string" && latest.version !== current);
      } catch (_) { /* Offline: keep current work and retry on foreground. */ }
    };
    check();
    window.addEventListener("salesmachine:foreground", check);
    document.addEventListener("visibilitychange", check);
    const timer = setInterval(check, 120000);
    return () => {
      active = false; clearInterval(timer);
      window.removeEventListener("salesmachine:foreground", check);
      document.removeEventListener("visibilitychange", check);
    };
  }, []);
  if (!available) return null;
  return <div role="status" className="fixed top-2 left-3 right-3 z-[110] rounded-xl border border-amber-400/40 bg-slate-950 p-3 shadow-xl text-sm text-white">
    Neue Version verfügbar. Speichere zuerst deine Eingaben.
    <button className="gold-btn rounded-lg px-3 py-2 ml-2" onClick={() => window.location.reload()}>Jetzt aktualisieren</button>
  </div>;
}
